<template>
  <div class="container" v-resize="getDelegateShowcase">
    <div class="row container-showcase align-start justify-center">
      <div class="section-title col-12 mb-40">
        <h3 class="title-keyword">{{ $t("all_showcase") }}</h3>
        <div
          class="line"
          style="width: 100%; height: 10px; background: #249d82"
        ></div>
      </div>
      <v-col ref="contentShowcase" cols="12" v-if="statusLoadShowcase === 0">
        <v-row class="d-flex justify-center">
          <div class="lds-facebook text-center">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </v-row>
      </v-col>
      <v-col ref="contentShowcase" cols="12" v-else>
        <v-row
          v-if="delegateShowcase && delegateShowcase.length"
          dense
          class="d-flex justify-space-between"
        >
          <v-col
            class="wow fadeInUp contents"
            cols="auto"
            :style="{
              width: `${content.width}%`,
            }"
            v-for="(content, i) in delegateShowcase"
            :key="i"
          >
            <v-img
              style="position: relative"
              :id="`img-${i}`"
              class="image-showcase"
              :src="content.url_poster"
              @click="onDetailPage(content)"
            >
              <img class="play-btn" src="/images/play.svg" />
              <div class="background-title-hover align-center">
                <div style="position: relative" class="text-container">
                  <h4 class="title-keyword">
                    {{ content.title }}
                  </h4>
                </div>
              </div>
            </v-img>
          </v-col>
        </v-row>
        <v-row v-else class="text-center d-flex justify-center">
          <span class="text-center grey--text">No data showcase</span>
        </v-row>
      </v-col>
    </div>
    <v-dialog v-model="dialog" width="500px">
      <form-request-live @close="dialog = false"></form-request-live>
    </v-dialog>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import FormRequestLive from "../LandingPage/components/FormRequestLive";

export default {
  name: "index",
  components: { FormRequestLive },
  async created() {
    await this.getAllShowcases();
    this.getDelegateShowcase();
  },
  data() {
    return {
      delegateShowcase: [],
      dialog: false,
    };
  },
  methods: {
    onDetailPage(content) {
      const dataRoute = {
        showcase_id: content.showcase_id,
      };
      switch (Number(content.type_showcase)) {
        case 3: // Click to buy
          this.$router.push({
            name: "InteractiveVideo",
            query: { ...dataRoute },
          });
          break;
        case 1: // All model AI
          this.$router.push({
            name: "ShowCaseAllModel",
            query: { ...dataRoute },
          });
          break;
        case 4: // BanderAds/TVC
          this.$router.push({
            name: "ContextualAdvertising",
            query: { ...dataRoute },
          });
          break;
        case 2: //Live stream
          // this.dialog = true;
          // break;
          this.$router.push({
            name: "DemoveRemBkgr",
          });
          break;
        case 5: //Poster
          this.$router.push({ name: "PosterImages", query: { ...dataRoute } });
          break;
        case 6: //Poster
          this.$router.push({ name: "CountClick", query: { ...dataRoute } });
          break;
        case 7: //Poster
          this.$router.push({ name: "ScreenMission", query: { ...dataRoute } });
          break;
        default:
          return;
      }
    },
    getAllShowcases: call("showcase/getAllShowcase"),
    getDelegateShowcase() {
      let result = [];
      let existedId = [];
      for (const showcase of this.contentShowcase) {
        if (!existedId.includes(showcase.type_showcase)) {
          if (window.innerWidth < 768) {
            showcase.width = 100;
          } else {
            if (showcase.type_showcase === 1) {
              showcase.width = (100 / 3) * 2;
            } else {
              showcase.width = 100 / 3;
            }
          }

          result.push(showcase);
          existedId.push(showcase.type_showcase);
        }
      }
      result.sort(function (t, e) {
        return t.type_showcase - e.type_showcase;
      });
      this.delegateShowcase = result;
    },
  },
  computed: {
    contentShowcase: sync("showcase/contentShowcase"),
    statusLoadShowcase: sync("showcase/statusLoadShowcase"),
  },
  mounted() {
    let nav = document.getElementById("nav");
    if (nav) {
      for (let el of nav.children) {
        if (el.id === "showcase") {
          el.classList.add("active");
        } else el.classList.remove("active");
      }
    }
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";

.topic-showcase {
  padding: 12px;
  //border-color: #666666;
  border: 2px $color-border solid;
  //background-color: #666666;
  //background: linear-gradient(to right, #fe8464 0%, #fe6e9a 50%, #fe8464 100%);
  margin-bottom: 6px;
  color: black;
  text-align: center;
  cursor: pointer;

  &.selected {
    background-color: $color-primary;
    color: white;
    //border: none;
    //background-image: linear-gradient(314deg, #1e453e 0%, #182c25 74%);
  }

  &:hover {
    color: white;
    background-color: $color-primary;
    background-image: $background-hover;
  }
}

@media only screen and (max-width: 1600px) {
  .topic-showcase {
    zoom: 0.75 !important;
  }
}

.contents {
  .image-showcase {
    border-radius: 8px;
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);

    .background-title-hover {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      background-color: rgba(70, 66, 66, 0.68);
      padding: 12px;
      opacity: 1;
      margin: auto;

      .title-keyword {
        font-weight: 400;
        font-size: 100%;
        color: white;
        text-align: center;
        pointer-events: none;
        opacity: 1;
      }
    }

    &:hover {
      -webkit-filter: grayscale(0); /* Safari 6.0 - 9.0 */
      filter: grayscale(0);

      .background-title-hover {
        background-color: $color-primary;
        color: white;
        border: none;
        opacity: 0.8;

        .title-keyword {
          opacity: 1 !important;
        }
      }
    }
  }

  .play-btn {
    position: absolute;
    width: 20%;
    height: 20%;
    top: 40%;
    left: 40%;

    &:hover {
      transform: scale(1.2);
      cursor: pointer;
    }
  }
}

.add-showcase {
  border-radius: 12px;
  border: $color-border 1px solid;
  cursor: pointer;

  &:hover {
    -webkit-filter: grayscale(0); /* Safari 6.0 - 9.0 */
    filter: grayscale(0);
    border: $color-border 2px solid;
  }

  .play-btn {
    position: absolute;
    width: 20%;
    height: 20%;
    top: 40%;
    left: 40%;

    &:hover {
      transform: scale(1.2);
      cursor: pointer;
      fill: $color-primary !important;
    }
  }

  .title-keyword {
    font-weight: 400;
    font-size: 20px;
    color: white;
    position: absolute;
    width: 70%;
    bottom: 12px;
    left: 15%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    pointer-events: none;
    z-index: 4;
  }
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 8px;
  width: 16px;
  background: #209b7f;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds-facebook div:nth-child(1) {
  left: 8px;
  animation-delay: -0.24s;
}
.lds-facebook div:nth-child(2) {
  left: 32px;
  animation-delay: -0.12s;
}
.lds-facebook div:nth-child(3) {
  left: 56px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 64px;
  }
  50%,
  100% {
    top: 24px;
    height: 32px;
  }
}
</style>
